export const ErrorMessageSuffix = {
    IPSAdminError: "IPSAdminError",
    SupplierAdminError: "SupplierAdminError",
};
